import React from 'react';
import { IonIcon } from '@ionic/react';
import { lockClosedOutline } from 'ionicons/icons';
import type { InvitePreview } from '@/services/meprfo';
import { pageHeaderTitleStyle } from './styles';

interface PrivateInvitePlaceholderProps {
  preview: InvitePreview;
  /** Verify/link-phone entry point (routes to the Profile Wizard). */
  onLinkPhone: () => void;
}

/**
 * Masked placeholder for a by-invitation-only topic the guest can't read yet:
 * a blurred preview image + "*****" title + a prompt to link a phone to unlock.
 */
const PrivateInvitePlaceholder: React.FC<PrivateInvitePlaceholderProps> = ({
  preview,
  onLinkPhone,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px 20px',
      textAlign: 'center',
      gap: '16px',
    }}
  >
    {preview.image && (
      <img
        src={preview.image}
        alt=""
        style={{
          width: '100%',
          maxWidth: 360,
          aspectRatio: '16 / 9',
          objectFit: 'cover',
          borderRadius: 12,
          filter: 'blur(2px)',
        }}
      />
    )}
    <h1 style={{ ...pageHeaderTitleStyle, letterSpacing: '0.15em' }}>*****</h1>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: 'var(--ion-color-medium)',
      }}
    >
      <IonIcon icon={lockClosedOutline} />
      <span>
        This is a private invite.{' '}
        <button
          type="button"
          onClick={onLinkPhone}
          data-testid="private-invite-link"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
            color: 'var(--ion-color-primary)',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Link your phone number
        </button>{' '}
        to view
      </span>
    </div>
  </div>
);

export default PrivateInvitePlaceholder;
